import {
  BodyElement,
  ColumnType,
  GridRow,
  RowVariant,
  StickyColumns,
} from './models';

const getRowVariant = (key: string, value: unknown) => {
  if (key === 'fullWidth') return '4';
  if (key === 'fourColumns') return '1-1-1-1';
  if (typeof value === 'object' && value !== null && 'rowVariant' in value)
    return value.rowVariant as string;

  throw new Error(
    `rowVariant in Splitter component for element ${key} is not correct`
  );
};

const isBodyElement = (
  element: [string, RowVariant | StickyColumns | BodyElement[]]
): element is [string, BodyElement[]] =>
  !!(element[0] !== 'rowVariant' && element[0] !== 'stickyColumns');

const transformRowVariant = (variant: string) => {
  const options = variant.split('-');
  if (options.length === 3)
    return options.map((option, index) => ({
      size: option,
      stretchVariant: index === 2 ? 'fill' : undefined,
    }));

  return options.map((option) => ({ size: option }));
};

const transformGridRowToColumns = (
  key: string,
  value: Record<string, BodyElement[] | RowVariant | StickyColumns>
): ColumnType[] => {
  if (!value) return [];

  const rowVariant = getRowVariant(key, value);
  const transformedVariants = transformRowVariant(rowVariant);

  const stickyColumnsSet = new Set<number>(
    (value?.stickyColumns as StickyColumns)?.map(Number)
  );

  return Object.entries(value)
    .filter(isBodyElement)
    .map(([, column], index) => ({
      column,
      isSticky: stickyColumnsSet.has(index + 1),
      ...transformedVariants[index],
    }));
};

export const transformGridToColumns = (grid: GridRow[]): ColumnType[] =>
  grid.flatMap((gridRow) =>
    Object.entries(gridRow).flatMap(([key, value]) =>
      transformGridRowToColumns(key, value)
    )
  );
